const DB = "ka_photos";
const STORE = "p";

function openDb() {
  return new Promise((resolve, reject) => {
    const r = indexedDB.open(DB, 1);
    r.onupgradeneeded = () => r.result.createObjectStore(STORE);
    r.onsuccess = () => resolve(r.result);
    r.onerror = () => reject(r.error);
  });
}

async function tx(mode, fn) {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const t = db.transaction(STORE, mode);
    const req = fn(t.objectStore(STORE));
    t.oncomplete = () => resolve(req?.result);
    t.onerror = () => reject(t.error);
  });
}

export const isLocal = (id) => typeof id === "string" && id.startsWith("local:");
export const putLocal = (id, blob) => tx("readwrite", (s) => s.put(blob, id));
export const getLocal = (id) => tx("readonly", (s) => s.get(id));
export const delLocals = (ids) => Promise.all((ids || []).filter(isLocal).map((id) => tx("readwrite", (s) => s.delete(id)))).catch(() => {});
